export default __webpack_public_path__ + "static/media/main-car1.c638fb57.png";